import Vue from 'vue';
import Vuex from 'vuex';
import { axios, axiosPersonal } from '../plugins/axios';

import accidenteLaboral from './accidenteLaboral';
import agudezasVisuales from './agudezasVisuales';
import agudezaVisual from './agudezaVisual';
import antecedentesAndrogenicos from './antecedentesAndrogenicos';
import antecedentesGinecoObstetricos from './antecedentesGinecoObstetricos';
import antecedentesHeredoFamiliares from './antecedentesHeredoFamiliares';
import antecedentesPatologicos from './antecedentesPatologicos';
import aparatoSistema from './aparatoSistema';
import armaPersonal from './armaPersonal';
import audiciones from './audiciones';
import bienes from './bienes';
import bienesPersonal from './bienesPersonal';
import biometrico from './biometrico';
import boletasArresto from './boletasArresto';
import datosLaborales from './datosLaborales';
import derivaciones from './derivaciones';
import desempeño from './desempeño';
import diagnostico from './diagnostico';
import dieta from './dieta';
import direcciones from './direcciones';
import droga from './droga';
import documento from './documento';
import ejercicio from './ejercicio';
import enfermedad from './enfermedad';
import estadoNutricional from './estadoNutricional';
import estatusCertificado from './estatusCertificado';
import estatusDerivaciones from './estatusDerivaciones';
import estatusProgramacion from './estatusProgramacion';
import evaluacionesAntecedentes from './evaluacionesAntecedentes';
import evaluacionesIntegracion from './evaluacionesIntegracion';
import evaluacionesISE from './evaluacionesISE';
import evaluacionesMedico from './evaluacionesMedico';
import evaluacionesPoligrafo from './evaluacionesPoligrafo';
import evaluacionesPsicologicas from './evaluacionesPsicologicas';
import evaluacionesValidacion from './evaluacionesValidacion';
import expediente from './expediente';
import exploracionNeurologica from './exploracionNeurologica';
import familiares from './familiares';
import frecuencia from './frecuencia';
import grupoAlimentos from './grupoAlimentos';
import grupoSanguineo from './grupoSanguineo';
import historiaClinica from './historiaClinica';
import imc from './imc';
import ingresos from './ingresos';
import interrogatorioAS from './interrogatorioAS';
import medicacionActual from './medicacionActual';
import medicamento from './medicamento';
import motivoEvaluacion from './motivoEvaluacion';
import motivoResultado from './motivoResultado';
import nivelConsumoAlcohol from './nivelConsumoAlcohol';
import nivelSocioEconomico from './nivelSocioEconomico';
import oido from './oido';
import ojos from './ojos';
import orientacion from './orientacion';
import parentesco from './parentesco';
import patologicas from './patologicas';
import peso from './peso';
import programacionEvaluacion from './programacionEvaluacion';
import pruebaOido from './pruebaOido';
import pruebaOjos from './pruebaOjos';
import pterigion from './pterigion';
import pupilas from './pupilas';
import reflejosOsteotendinosos from './reflejosOsteotendinosos';
import region from './region';
import regionExploracion from './regionExploracion';
import resultado from './resultado';
import sancionesAdministrativas from './sancionesAdministrativas';
import servicioMedico from './servicioMedico';
import sexo from './sexo';
import sintomas from './sintomas';
import sintomasAS from './sintomasAS';
import solicitudes from './solicitudes';
import somatometria from './somatometria';
import talla from './talla';
import tiempo from './tiempo';
import tipoBebida from './tipoBebida';
import tipoEjercicio from './tipoEjercicio';
import tipoEnfermedad from './tipoEnfermedad';
import tipoEvaluacion from './tipoEvaluacion';
import tipoServicio from './tipoServicio';
import tipoSolicitud from './tipoSolicitud';
import tipoTiroides from './tipoTiroides';
import tipoVivienda from './tipoVivienda';
import tipoZoonosis from './tipoZoonosis';
import tonoMuscular from './tonoMuscular';
import vehiculos from './vehiculos';
import vivienda from './vivienda';
import zoonosis from './zoonosis';
import tipoExpediente from './tipoExpediente';
import evaluadores from './evaluadores';
import parentescoHeredoFamiliar from './parentescoHeredoFamiliar';
import seguimientoEvaluaciones from './seguimientoEvaluaciones';
import preaspirante from './preaspirante';
import estadoCivil from './estadoCivil';
import puesto from './puesto';
import dependencia from './dependencia';
import areas from './areas';
import personal from './personal';
import estudio from './estudio';
import estatusEstudios from './estatusEstudios';
import comprobanteEstudios from './comprobanteEstudios';
import rama from './rama';
import tipoDocumento from './tipoDocumento';
import modelo from './modelo';
import color from './color';
import situacionFinanciera from './situacionFinanciera';
import municipio from './municipio';
import informeAlcance from './informeAlcance';
import numerales from './numerales';
import estatusEvaluacion from './estatusEvaluacion';
import estatusInformeAlcance from './estatusInformeAlcance';
import tipoDieta from './tipoDieta';
import tipoArma from './tipoArma';
import semaforoResultado from './semaforoResultado';
import dialog from './dialog';
import preregistro from './preregistro';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    perfil: localStorage.getItem('perfil') || '',
    nombre: localStorage.getItem('nombre') || '',
    idPersonal: localStorage.getItem('idPersonal') || '',
    idUsuario: localStorage.getItem('idUsuario') || '',
    loader: true,
    snackbar: {
      active: false,
      message: '',
    },
    userInfo: {
      apellido: '',
      curp: '',
      nombre: 'Usuario',
      numero_empleado: '123456',
      rfc: '',
      perfiles: [
        {
          perfil: '',
        },
      ],
    },
    selectedRole: null,
  },

  getters: {
    getLoader: (state) => state.loader,

    getSnackbar: (state) => state.snackbar,

    getPerfil: (state) => state.perfil,

    getNombre: (state) => state.nombre,

    getIdPersonal: (state) => state.idPersonal,

    getIdUsuario: (state) => state.idUsuario,

    getUserName(state) {
      return `${state.userInfo.nombre} ${state.userInfo.apellido}`;
    },

    getUserEmployeeId(state) {
      return state.userInfo.numero_empleado;
    },

    getUserProfile(state) {
      if (state.userInfo.perfiles.length > 0) {
        return state.userInfo.perfiles[0].perfil;
      }

      return '';
    },

    getSelectedRole(state) {
      return state.selectedRole;
    },
  },

  mutations: {
    DISABLE_LOADER(state) {
      state.loader = false;
    },

    ENABLE_LOADER(state) {
      state.loader = true;
    },

    SET_SNACKBAR_MESSAGE(state, message) {
      state.snackbar = {
        active: true,
        message,
      };
    },

    SET_PERFIL(state, perfil) {
      state.perfil = perfil;
    },

    SET_NOMBRE(state, nombre) {
      state.nombre = nombre;
    },

    SET_ID_PERSONAL(state, idPersonal) {
      state.idPersonal = idPersonal;
    },

    SET_ID_USUARIO(state, idUsuario) {
      state.idUsuario = idUsuario;
    },

    SET_USER_INFO(state, payload) {
      state.userInfo = { ...payload };
    },

    SET_SELECTED_ROLE(state, role) {
      Vue.set(state, 'selectedRole', role);
    },
  },

  actions: {
    async login({ commit }, user) {
      await axios
        .post('PoliciaCuadrantes/login', user)
        .then((res) => {
          if (res.data.data[0].token.length > 0) {
            const { token } = res.data.data[0];
            const { perfil } = res.data.data[0].extraInfo;
            const nombre = res.data.data[0].fullName;
            const idPersonal = res.data.data[0].fk_idPersonal;
            const idUsuario = res.data.data[0].id;
            sessionStorage.setItem('token', token);
            localStorage.setItem('perfil', perfil);
            localStorage.setItem('nombre', nombre);
            localStorage.setItem('idPersonal', idPersonal);
            localStorage.setItem('idUsuario', idUsuario);
            commit('SET_PERFIL', perfil);
            commit('SET_NOMBRE', nombre);
            commit('SET_ID_PERSONAL', idPersonal);
            commit('SET_ID_USUARIO', idUsuario);
            commit('SET_SNACKBAR_MESSAGE', 'Inicio de sesión realizado. Redirigiendo al launcher.');

            axios.defaults.headers.common.Authorization = token;

            switch (perfil) {
              case 'Programación':
                window.location.replace('programacion/expedientes');
                break;
              case 'Médico':
                window.location.replace('evaluaciones_medicas/personal');
                break;
              case 'Poligrafía':
                window.location.replace('evaluaciones_poligraficas/personal');
                break;
              case 'Psicología':
                window.location.replace('evaluaciones_psicologicas/personal');
                break;
              case 'Antecedentes':
                window.location.replace('investigacion_socioeconomica/antecedentes');
                break;
              case 'Validación':
                window.location.replace('investigacion_socioeconomica/validacion');
                break;
              case 'ISE':
                window.location.replace('investigacion_socioeconomica/ise');
                break;
              case 'Integración':
                window.location.replace('integracion/personal');
                break;
              case 'C3':
                window.location.replace('/launcher');
                break;
              default:
                break;
            }
          } else {
            commit('SET_SNACKBAR_MESSAGE', 'No pudo realizarse el inicio de sesión. Por favor, verifique sus credenciales.');
          }
        })
        .catch(() => commit('SET_SNACKBAR_MESSAGE', 'No pudo realizarse el inicio de sesión. Por favor, verifique sus credenciales.'));
    },

    async searchPersonal(_, employeeNumber) {
      const response = await axiosPersonal.post('/EonCloud/EstadoFuerza/search/personal', {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        curp: '',
        CUIP: employeeNumber,
      });

      return response.data.data;
    },

    async passwordReset({ commit }, user) {
      await axios
        .put('/PoliciaCuadrantes/passwords', user)
        .then(() => {
          commit('SET_SNACKBAR_MESSAGE', 'Su contraseña ha sido actualizada.');
        })
        .catch(() => commit('SET_SNACKBAR_MESSAGE', 'No pudo realizarse el cambio de contraseña. Por favor, intente nuevamente.'));
    },
  },

  modules: {
    accidenteLaboral,
    agudezasVisuales,
    agudezaVisual,
    antecedentesAndrogenicos,
    antecedentesGinecoObstetricos,
    antecedentesHeredoFamiliares,
    antecedentesPatologicos,
    aparatoSistema,
    armaPersonal,
    audiciones,
    bienes,
    bienesPersonal,
    biometrico,
    boletasArresto,
    datosLaborales,
    derivaciones,
    desempeño,
    diagnostico,
    dieta,
    direcciones,
    droga,
    ejercicio,
    enfermedad,
    estadoNutricional,
    estatusCertificado,
    estatusDerivaciones,
    estatusProgramacion,
    evaluacionesAntecedentes,
    evaluacionesIntegracion,
    evaluacionesISE,
    evaluacionesMedico,
    evaluacionesPoligrafo,
    evaluacionesPsicologicas,
    evaluacionesValidacion,
    expediente,
    exploracionNeurologica,
    familiares,
    frecuencia,
    grupoAlimentos,
    grupoSanguineo,
    historiaClinica,
    imc,
    ingresos,
    interrogatorioAS,
    medicacionActual,
    medicamento,
    motivoEvaluacion,
    motivoResultado,
    nivelConsumoAlcohol,
    nivelSocioEconomico,
    oido,
    ojos,
    orientacion,
    parentesco,
    patologicas,
    peso,
    programacionEvaluacion,
    pruebaOido,
    pruebaOjos,
    pterigion,
    pupilas,
    reflejosOsteotendinosos,
    region,
    regionExploracion,
    resultado,
    sancionesAdministrativas,
    servicioMedico,
    sexo,
    sintomas,
    sintomasAS,
    solicitudes,
    somatometria,
    talla,
    tiempo,
    tipoBebida,
    tipoEjercicio,
    tipoEnfermedad,
    tipoEvaluacion,
    tipoServicio,
    tipoSolicitud,
    tipoTiroides,
    tipoVivienda,
    tipoZoonosis,
    tonoMuscular,
    vehiculos,
    vivienda,
    zoonosis,
    documento,
    tipoExpediente,
    evaluadores,
    parentescoHeredoFamiliar,
    seguimientoEvaluaciones,
    preaspirante,
    estadoCivil,
    puesto,
    dependencia,
    areas,
    personal,
    estudio,
    estatusEstudios,
    comprobanteEstudios,
    rama,
    tipoDocumento,
    modelo,
    color,
    situacionFinanciera,
    municipio,
    informeAlcance,
    numerales,
    estatusEvaluacion,
    estatusInformeAlcance,
    tipoDieta,
    tipoArma,
    semaforoResultado,
    dialog,
    preregistro,
  },
});
